import { render } from "./OtaUpdate.vue?vue&type=template&id=48de2eba"
import script from "./OtaUpdate.vue?vue&type=script&lang=js"
export * from "./OtaUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Shared/Previously Relocated Items/Security/data/www/solo/CyReport/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__